import React, { useEffect } from "react";
import { authService } from "../services/authService";

export const AuthCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const refreshToken = params.get("refresh_token");

    if (token) {
      authService.setToken(token);
    }
    if (refreshToken) {
      authService.setRefreshToken(refreshToken);
    }

    window.location.href = "/";
  }, []);

  return <div className="card">Completing sign-in...</div>;
};
